var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polyline, _polygon5, _polygon6, _polygon7, _polygon8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpcCastor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#758c8e;}.cls-2{fill:#fff;opacity:.6;}.cls-3{fill:#2e3c3d;}.cls-4{fill:#242d2d;}.cls-5{fill:aqua;}.cls-6{fill:#455a5b;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "415.87 375.29 368 215.65 353.34 192.73 339 215.65 290.82 375.09 353.34 405.19 415.87 375.29"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "262.29 479.54 441.94 479.54 454.04 460.17 252.61 460.17 262.29 479.54"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "298.89 514.13 406.01 514.13 419.43 489.84 286.56 489.84 298.89 514.13"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "282.12 497.37 422.12 497.37 435.92 478.93 270.74 478.93 282.12 497.37"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "353.14 404.98 415.66 375.08 367.79 215.44 353.14 192.52"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "316.48 460.93 252.43 460.56 305.73 304.53 338.33 269.44 316.48 460.93"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "390.17 460.93 454.22 460.56 400.92 304.53 368.31 269.44 390.17 460.93"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "285 460.65 316 460.65 339 269.65 285 460.65"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "421.57 460.65 390.57 460.65 367.57 269.65 421.57 460.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcCastor);
export default __webpack_public_path__ + "static/media/npc-castor.e53b7e5bb19318790ed20ec2c1b76485.svg";
export { ForwardRef as ReactComponent };